import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@/i18n/labels';

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  padding: '2rem',
};

const cardStyle: React.CSSProperties = {
  maxWidth: 420,
  textAlign: 'center',
  padding: '2rem',
  border: '1px solid #e5e7eb',
  borderRadius: 12,
  background: '#fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const headingStyle: React.CSSProperties = {
  margin: '0 0 0.5rem',
  fontSize: '1.25rem',
  color: '#111827',
};

const messageStyle: React.CSSProperties = {
  margin: '0 0 1.5rem',
  color: '#6b7280',
  fontSize: '0.9375rem',
};

const linkStyle: React.CSSProperties = {
  display: 'inline-block',
  padding: '0.5rem 1.25rem',
  background: '#3b82f6',
  color: '#fff',
  borderRadius: 8,
  textDecoration: 'none',
  fontSize: '0.875rem',
};

interface ForbiddenProps {
  /**
   * Optional override for the explanatory line. Defaults to the canonical RBAC
   * denial copy (asserted by the OP-179 / ProtectedRoute tests — do not change
   * the default). Used by <RequireScope> to explain a plane mismatch (e.g.
   * "Select a tenant first").
   */
  message?: string;
}

/**
 * Rendered in place (no redirect) when an authenticated user lacks the
 * permission a route requires (or, via <RequireScope>, is in the wrong plane).
 * Mirrors the inline-style idiom used by the other common components
 * (LoadingSpinner, etc.).
 */
export const Forbidden: React.FC<ForbiddenProps> = ({ message }) => {
  const { t } = useT();
  return (
    <div style={wrapperStyle} role="alert">
      <div style={cardStyle}>
        <h2 style={headingStyle}>{t('forbiddenTitle')}</h2>
        <p style={messageStyle}>{message ?? t('forbiddenDefaultMessage')}</p>
        <Link to="/" style={linkStyle}>
          {t('forbiddenBack')}
        </Link>
      </div>
    </div>
  );
};
